export interface EndedTail { key: string; head: number; start: number }

/** Late messages may move the data head forward, but cannot rewind an already draining display. */
export function anchorEndedTail(previous: EndedTail | null, key: string, durationMs: number, now: number): EndedTail {
  const previousHead = previous?.key === key ? previous.head + Math.min(120_000, Math.max(0, now - previous.start)) : 0;
  return { key, head: Math.max(durationMs, previousHead), start: now };
}
export function endedHead(tail: EndedTail, durationMs: number, now: number): number {
  return Math.min(durationMs + 120_000, tail.head + Math.max(0, now - tail.start));
}
